import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getReplies } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnReplies: ColumnHelperMethodType = (columnHelper) => {
  return columnHelper.accessor((row) => row.contentId, {
    id: 'Replies',
    cell: ({ row }) => <TextCell>{getReplies(row.original)}</TextCell>,
  });
};
